<template>
  <div id="containt" style="padding-left: 10px;">

    <div class="grid-height" style=" height: calc(100vh - -77px);">
      <vxe-grid align="center" show-overflow :stripe="true" :border="true" height="100%"
        :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
        @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">

        <template #form>
          <div class="clearfix screen-btns" style="margin-top: 3px;">
            <div class="fl">
              <vxe-button v-if="parts_return_report_export" status="primary" class="button-sty" icon="el-icon-plus" @click="doExcle">导出</vxe-button>
            </div>
            <div class="fr">
              <vxe-button status="warning" icon="el-icon-search" class="button-sty" @click="searchEvent">搜索</vxe-button>
            </div>
          </div>
          <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="requestParam"
            @submit="searchEvent" @reset="searchEvent">
            <vxe-form-item title="单据状态:">
              <template v-slot>
                <el-select
                  v-model="formData.statList"
                  multiple
                  :collapse-tags="true"
                  style="width:9vw ;"
                  placeholder="请选择">
                  <el-option :value="1" label="申请"></el-option>
                  <el-option :value="3" label="审核"></el-option>
                  <el-option :value="5" label="入库"></el-option>
                  <el-option :value="9" label="驳回"></el-option>
                  <el-option :value="99" label="取消"></el-option>
                </el-select>
              </template>
            </vxe-form-item>

            <vxe-form-item title="服务中心:">
              <template v-slot >
                <org-search :org-name.sync="formData.orgName"
                            :org-id-path.sync="formData.orgIdPath"
                            :org-id.sync="formData.orgId"
                            :show="!currentIsSite"
                            style="width:9vw ;"
                            @change="() => {
                              formData.siteId = null
                              formData.siteName = null
                              formData.childSiteId = null
                              formData.childSiteName = null
                            }"
                />
              </template>
            </vxe-form-item>

            <vxe-form-item title="服务商:">
              <template v-slot >
                <site-pop-search :site-id.sync="formData.siteId"
                                 :site-name.sync="formData.siteName"
                                 :org-name.sync="formData.orgName"
                                 :org-id-path.sync="formData.orgIdPath"
                                 :org-id.sync="formData.orgId"
                                 :editable="!currentIsSite"
                                 :param="{siteFloorLevel: 1}"
                                 @valueChange="() => {formData.childSiteId = null; formData.childSiteName = null}"
                                 style="width:9vw ;"/>
              </template>
            </vxe-form-item>

            <vxe-form-item title="下级服务商:">
              <template v-slot >
                <child-site-pop-search :site-id.sync="formData.childSiteId"
                                       :site-name.sync="formData.childSiteName"
                                       :parent-site-id.sync="formData.siteId"
                                       :org-name.sync="formData.orgName"
                                       :org-id-path.sync="formData.orgIdPath"
                                       :org-id.sync="formData.orgId"
                                       style="width:9vw ;"
                />
              </template>
            </vxe-form-item>
            <vxe-form-item title="返厂单创建时间:" field="name" style="width:25%!important;">
              <template v-slot style=" display: inline-block;width:25%!important;">
                <el-date-picker style="width: 16vw;" v-model="formData.createTime" type="daterange" align="right"
                                unlink-panels range-separator="-" start-placeholder="开始日期"
                                end-placeholder="结束日期" :clearable="false"
                                :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                </el-date-picker>
              </template>
            </vxe-form-item>
            <vxe-form-item title="返厂单号:">
              <template v-slot >
                <el-input v-model="formData.returnNo" size="small" clearable style="width:9vw ;"/>
              </template>
            </vxe-form-item>
            <vxe-form-item title="工单号:">
              <template v-slot >
                <el-input v-model="formData.orderNo" size="small" clearable style="width:9vw ;"/>
              </template>
            </vxe-form-item>

            <vxe-form-item title="物流单号:">
              <template v-slot >
                <el-input v-model="formData.deliverNo" size="small" clearable style="width:9vw ;"/>
              </template>
            </vxe-form-item>

            <vxe-form-item title="返厂类型" field="name">
              <template v-slot>
                <el-select
                  v-model="formData.returnTypeList"
                  :multiple="true"
                  :collapse-tags="true"
                  style="width:9vw ;"
                  placeholder="请选择">
                  <el-option :value="1" label="旧件返厂"></el-option>
                  <el-option :value="2" label="坏件返厂"></el-option>
                  <el-option :value="3" label="好件返厂"></el-option>
                  <el-option :value="4" label="就地报废"></el-option>
                  <el-option :value="9" label="其他返厂"></el-option>
                </el-select>
<!--                <el-input v-model="formData.sendNo" size="small" style="width:9vw ;visibility: hidden" clearable/>-->
              </template>
            </vxe-form-item>

            <vxe-form-item title="审核时间:" field="name" style="width:25%!important;">
              <template v-slot style=" display: inline-block;width:25%!important;">
                <el-date-picker style="width: 16vw;" v-model="formData.checkTime" type="daterange" align="right"
                                unlink-panels range-separator="-" start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                </el-date-picker>
              </template>
            </vxe-form-item>
            <vxe-form-item title="冲账时间:" field="name" style="width:15%!important;">
              <template v-slot style=" display: inline-block;width:15%!important;">
                <el-date-picker style="width: 16vw;" v-model="formData.send3Time" type="daterange" align="right"
                                unlink-panels range-separator="-" start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                </el-date-picker>
              </template>
            </vxe-form-item>
            <vxe-form-item title="工单创建时间:" field="name" style="width:15%!important;">
              <template v-slot style=" display: inline-block;width:25%!important;">
                <el-date-picker style="width: 16vw;" v-model="formData.soCreateTime" type="daterange" align="right"
                                unlink-panels range-separator="-" start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                </el-date-picker>
              </template>
            </vxe-form-item>
          </vxe-form>
        </template>
        <!-- 分页器 -->
        <template #pager>
          <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
        </template>

        <template #stat="{ row }">
          <span class="txt-status " v-if="row.stat == 0">制单</span>
          <span class="txt-status " v-else-if="row.stat == 1">申请</span>
          <span class="txt-status neutral" v-else-if="row.stat == 2">审核</span>
          <span class="txt-status " v-else-if="row.stat == 3">已发货</span>
          <span class="txt-status " v-else-if="row.stat == 4">已收货</span>
          <span class="txt-status disable" v-else-if="row.stat == 9">驳回</span>
          <span class="txt-status " v-else-if="row.stat == 98">已结算</span>
          <span class="txt-status disable" v-else-if="row.stat == 99">取消</span>
          <span v-else></span>
        </template>

        <template #collectStat="{ row }">
          <span v-if="row.collectStat == 0" class="txt-status">未交货</span>
          <span v-else-if="row.collectStat == 1" class="txt-status neutral">部分交货</span>
          <span v-else-if="row.collectStat == 2" class="txt-status neutral">完全交货</span>
          <span v-else></span>
        </template>

        <template #areaSlots="{ row }">
          <span>{{ row.deliverProvince }}{{ row.deliverCity }}{{ row.deliverCounty }}{{ row.deliverTown }}</span>
        </template>

        <template #outTypeSlots="{ row }">
          <span v-if="row.outType == 1">总部</span>
          <span v-else-if="row.outType == 2">中心</span>
        </template>

        <template #outStatSlots="{ row }">
          <span v-if="row.outStat == 0">未发货</span>
          <span v-else-if="row.outStat == 1">部分发货</span>
          <span v-else-if="row.outStat == 2">完全发货</span>
        </template>

        <template #showInStat="{ row }">
          <span v-if="row.inStat == 0">未入库</span>
          <span v-else-if="row.inStat == 1">部分入库</span>
          <span v-else-if="row.inStat == 2">完全入库</span>
        </template>

        <template #getStatSlots="{ row }">
          <span v-if="row.getStat == 0">未收货</span>
          <span v-else-if="row.getStat == 1">部分收货</span>
          <span v-else-if="row.getStat == 2">完全收货</span>
        </template>

        <template #send1FlagSlots="{ row }">
          <span v-if="row.send1Flag == 1" class="txt-status disable">失败</span>
          <span v-else-if="row.send1Flag == 2" class="txt-status neutral">已传</span>
          <span v-else-if="row.send1Flag == 0" class="txt-status">未传</span>
        </template>

        <template #showReturnType="{row}">
          <span class="txt-status neutral" v-if="row.returnType == 1">旧件返厂</span>
          <span class="txt-status neutral" v-else-if="row.returnType == 2">坏件返厂</span>
          <span class="txt-status " v-else-if="row.returnType == 3">好件返厂</span>
          <span class="txt-status disable" v-else-if="row.returnType == 4">就地报废</span>
          <span class="txt-status neutral" v-else-if="row.returnType == 9">其他返厂</span>
        </template>

        <template #showSend3Flag="{row}">
          <span class="txt-status neutral" v-if="row.send3Flag == 0">未冲账</span>
          <span class="txt-status neutral" v-else-if="row.send3Flag == 4">冲帐中</span>
          <span class="txt-status " v-else-if="row.send3Flag == 2">冲账成功</span>
          <span class="txt-status disable" v-else-if="row.send3Flag == 1">冲账失败</span>
        </template>

        <template #showStat="{row}">
          <span class="txt-status "  v-if="row.stat == 1">申请</span>
          <span class="txt-status " v-else-if="row.stat == 0">制单</span>
          <span class="txt-status neutral" v-else-if="row.stat == 3">审核</span>
          <span class="txt-status " v-else-if="row.stat == 5">入库</span>
          <span class="txt-status disable" v-else-if="row.stat == 9">驳回</span>
          <span class="txt-status disable" v-else-if="row.stat == 99">取消</span>
          <span v-else></span>
        </template>

        <template #showSitePrice="{ row }">
          <span v-if="currentSiteLevel == 2 || currentIsSite">*</span>
          <span v-else>{{ row.sitePrice }}</span>
        </template>
        <template #showDiffAmount="{ row }">
          <span v-if="currentSiteLevel == 2 || currentIsSite">*</span>
          <span v-else>{{ row.diffAmount }}</span>
        </template>
        <template #showInAmount="{ row }">
          <span v-if="currentSiteLevel == 2 || currentIsSite">*</span>
          <span v-else>{{ row.inAmount }}</span>
        </template>
        <template #showReturnAmount="{ row }">
          <span v-if="currentSiteLevel == 2 || currentIsSite">*</span>
          <span v-else>{{ row.returnAmount }}</span>
        </template>


      </vxe-grid>
    </div>

  </div>
</template>

<script>
import { initVxeTable } from '@/const/crud/admin/table'
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import OrgSearch from "@/components/formItem/orgSearch.vue";
import SitePopSearch from "@/components/formItem/sitePopSearch.vue";
import ChildSitePopSearch from "@/components/formItem/childSitePopSearch.vue";
import fileNames from "@/api/intfDownloadRecord/fileNames";
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
import {siteMixins} from "@/mixins/tabChang";
import {mapGetters} from "vuex";
// import { initVxeTable } from '@/const/crud/admin/fakeDataTable'

export default {
  name: 'partsReturnReport',
  mixins: [siteMixins],
  components: {ChildSitePopSearch, SitePopSearch, OrgSearch, pager },
  data() {
    return {
      parts_return_report_export: false,
      getPageDataUrl: '/basic/basCompanyBarcode/getListPage',
      showEdit: false,
      editViewDataUpdateFlag: false,
      activeName: 'second',
      dataId: 0,
      pageSizes: [10, 20, 100],
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 10,  // 页面数据量

        statList: null,
        orderTypeList: null,
        planTypeList: null,
        applyTypeList: null,
        createTime: null,
        returnNo: null,
        orgIdPath: null,
        siteId: null,
        childSiteId: null,
        checkTime: null,
        orderNo: null,
        sendNo: null,
        collectNo: null,
        deliverNo: null,
        collectTime: null,
        returnTypeList: null,
        send3Time: null,
        soCreateTime:null,
      },
      formData: {
        statList: null,
        orderTypeList: null,
        planTypeList: null,
        applyTypeList: null,
        createTime: null,
        returnNo: null,
        orgIdPath: null,
        siteId: null,
        childSiteId: null,
        checkTime: null,
        orderNo: null,
        sendNo: null,
        collectNo: null,
        deliverNo: null,
        collectTime: null,
        returnTypeList: null,
        send3Time:null,
        soCreateTime:null,
      },
      searchBarcode: '',
      searchItemCode: '',
      searchItemName: '',
      total: 0,  // 数据总数
      vxeOption: {},
      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      columns: [
        {title: '返厂单号', field: 'returnNo', width: 180, },
        {
          title: '状态', field: 'stat', width: 100, slots: {
            default: 'showStat'
          }
        },
        {
          title: '返厂类型', field: 'returnType', width: 130,
          slots: {
            default: 'showReturnType'
          }
        },
        {title: '冲帐状态', field: 'send3Flag', width: 130, slots: {default: 'showSend3Flag'}},
        {title: '冲账单号', field: 'send3No', width: 130,},
        {title: '冲账时间', field: 'send3Date', width: 130,},
        {title: '服务中心', field: 'orgName', width: 130,},
        {title: '服务商', field: 'siteName', width: 130,},
        {title: '工程师姓名', field: 'engineerName', width: 130,},
        {title: '发出地址', field: 'deliverAddress', width: 280,},
        {title: '发出人', field: 'deliverMan', width: 150,},
        {title: '发出电话', field: 'deliverMobile', width: 150,},
        {title: '物流公司', field: 'deliverCompanyName', width: 150,},
        {title: '物流单号', field: 'deliverNo', width: 150,},
        {title: '备注', field: 'remark', width: 180,},
        {title: '入库状态', field: 'inStat', width: 150,slots: {default: 'showInStat'}},
        {title: '关联工号', field: 'orderNo', width: 180,},
        {title: '产品品牌', field: 'brandName', width: 100,},
        {title: '工单创建时间', field: 'soCreateTime', width: 180,},
        {title: '工单对应服务商', field: 'orderSiteName', width: 180,},
        {title: '产品大类', field: 'categoryName', width: 150,},
        {title: '配件编码', field: 'partsCode', width: 150,},
        {title: '配件名称', field: 'partsName', width: 180,},
        {title: '袋码', field: 'packageNo', width: 180,},
        {title: '价格', field: 'sitePrice', width: 180, slots: {default: 'showSitePrice'}},
        {title: '冲账金额', field: 'czAmount', width: 180,},
        {title: '返厂数量', field: 'returnQty', width: 120,},
        {title: '返厂金额', field: 'returnAmount', width: 120, slots: {default: 'showReturnAmount'}},
        {title: '入库数量', field: 'inQty', width: 120,},
        {title: '入库金额', field: 'inAmount', width: 120, slots: {default: 'showInAmount'}},
        {title: '差异数量', field: 'diffQty', width: 120,},
        {title: '差异金额', field: 'diffAmount', width: 120, slots: {default: 'showDiffAmount'}},
        {title: '创建人', field: 'createBy', width: 80,},
        {title: '返厂单创建时间', field: 'createTime', width: 150,},
        {title: '审核时间', field: 'checkDate', width: 150,},
        {title: '入库时间', field: 'inDate', width: 150,},
        {title: '驳回时间', field: 'rejectDate', width: 150,},

        {title: '独立包装物料编码/条码', field: 'independentBarcode', width: 150,},
        {title: '旧件扫码二维码完整信息', field: 'partsBarcode', width: 150,},
        {title: '总部扫入旧件二维码信息', field: 'companyComfirmPartBarcode', width: 150,},
        {title: '校验结果', field: 'checkResult', width: 150,}   ,
        {title: '整机条码', field: 'itemBarcode', width: 150,},
        {title: '扫码的物料编码', field: 'itemCodeSc', width: 150,},
        {title: '供应商名称', field: 'supplier', width: 150,},
        {title: '扫码的供应商编码', field: 'supplierCode', width: 150,},
        {title: '扫码的供应商物料批次号', field: 'supplierItemBatch', width: 150,},
        {title: 'OEM厂商代码', field: 'oemCode', width: 150,},
        {title: '购买时间', field: 'buyDate', width: 150,},
        {title: '购买渠道', field: 'channelName', width: 150,},
        {title: '产品编码', field: 'itemCode', width: 150,},
        {title: '产品名称', field: 'itemName', width: 150,},
        {title: '故障现象', field: 'symptomName', width: 150,},
        {title: '故障原因', field: 'reasonName', width: 150,},
        {title: '服务需求', field: 'appeals', width: 150,},
        {title: '完工备注', field: 'finishNote', width: 150,},
        {title: '维修措施', field: 'methodName', width: 150,},
        {title: '创建日期', field: 'orderCreateTime', width: 150,},
        {title: '省', field: 'orderProvice', width: 150,},
        {title: '市', field: 'orderCity', width: 150,},

      ],
    };
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    }
  },
  created() {
    this.parts_return_report_export = this.permissions['parts_return_report_export']
  },
  mounted() {
    this.initSearchDate()
  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  methods: {
    setSiteData() {
      this.formData.siteId = this.currentSiteData.id
      this.formData.siteName = this.currentSiteData.userName
      this.formData.orgIdPath = this.currentSiteData.snSiteInfoDTO.orgIdPath
      this.formData.orgId = this.currentSiteData.snSiteInfoDTO.orgId
      this.formData.orgName = this.currentSiteData.snSiteInfoDTO.orgName
      this.$objCopy(this.formData, this.requestParam)
    },


    //导出
    doExcle(){
      this.$mask.open()
      doCheckExcle(fileNames.returnPartsReport).then(response => {
        if (response.data.msg=="success"){
          doDownLoadExcle(api.partsReturnReport.doExcelUrl, this.requestParam).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          }).catch(() => {
            this.$mask.close()
          })
        }else{
          this.$mask.close()
          this.$message({
            type: "error",
            message: response.data.msg
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },
    // 初始化搜索时间
    initSearchDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = this.$formatDateTime(end, 'yyyy-MM-dd');
start = this.$formatDateTime(start, 'yyyy-MM-dd');
      this.formData.createTime = [start, end]
      this.requestParam.createTime = [start, end]
    },
    mergeRowMethod({ row, _rowIndex, column, visibleData }) {
      // const fields = ['applyQty', 'checkQty', 'collectQty', 'outQty', 'getQty']
      const cellValue = row[column.property]
      // if (cellValue && !fields.includes(column.property)) {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        if (prevRow && prevRow[column.property] === cellValue) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[column.property] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      // }
    },
    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.partsReturnReport.getPage,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData()
    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 重置
    resetEvent() {
      this.searchBarcode = ''
      this.searchItemName = ''
      this.searchItemCode = ''
      this.requestParam.searchCount = false
      this.requestParam.barcode = ''
      this.requestParam.itemCode = ''
      this.requestParam.itemName = ''
      this.requestParam.current = 1
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 新增
    openEditDialog(id) {
      console.log(id)
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },

    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },
  }
};
</script>
<style lang="scss" >
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}


</style>
